import { ISettingsState } from 'state/settings/settings.types'

export const SettingsState: ISettingsState = {
  loaders: {
    orderSettingLoader: false,
    livesaleSettingLoader: false
  },
  distance: {},
  drawers: {
    orderSettings: false,
    livesaleSettings: false
  },
  businessSettings: null,
  gdrive: {
    connected: false,
    imageBackupDestination: '',
    email: null,
    displayName: null,
    photoUrl: null,
    usageBytes: null,
    limitBytes: null,
    syncing: false,
    loading: false,
    lastCheckedAt: null,
    lastSyncTime: null
  }
}
